var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeScreen === _vm.ScreensEnum.transcript,
            expression: "activeScreen === ScreensEnum.transcript",
          },
        ],
        staticClass: "container-fluid",
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", [
            _c("div", { staticClass: "panel" }, [
              _c(
                "div",
                {
                  staticClass:
                    "clearfix panel-heading branding-background branding-text chat-heading",
                },
                [
                  _c("h3", { staticClass: "panel-title pull-left" }, [
                    _vm._v("Chat Ended"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pull-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "branding-text close-chat",
                        attrs: { href: "", title: "Close Chat" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.nextScreen(_vm.ScreensEnum.chatButton)
                          },
                        },
                      },
                      [_c("i", { staticClass: "glyphicon glyphicon-remove" })]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c("p", [
                  _vm._v(
                    "If you would like a transcript of this chat, please enter your email address below."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { "has-error": _vm.isUserEmailChangedAndInvalid },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userEmail,
                          expression: "userEmail",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "email",
                        type: "text",
                        id: "userEmail",
                        maxlength:
                          "@VT.DataStore.Models.VisualTour.ChatSession.InitiateEmailAddressMaxLength",
                      },
                      domProps: { value: _vm.userEmail },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.emailTranscript.apply(null, arguments)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.userEmail = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("email"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg branding-background branding-text",
                    attrs: { id: "" },
                    on: { click: _vm.emailTranscript },
                  },
                  [_vm._v("Send Transcript")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeScreen === _vm.ScreensEnum.transcriptSuccess,
            expression: "activeScreen === ScreensEnum.transcriptSuccess",
          },
        ],
        staticClass: "container-fluid",
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", [
            _c("div", { staticClass: "panel" }, [
              _c(
                "div",
                {
                  staticClass:
                    "clearfix panel-heading branding-background branding-text chat-heading",
                },
                [
                  _c("h3", { staticClass: "panel-title pull-left" }, [
                    _vm._v("Chat Ended"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pull-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "branding-text close-chat",
                        attrs: { href: "", title: "Close Chat" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.nextScreen(_vm.ScreensEnum.chatButton)
                          },
                        },
                      },
                      [_c("i", { staticClass: "glyphicon glyphicon-remove" })]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "userEmail" } }, [
      _vm._v("Email "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-body" }, [
      _c("p", [_c("strong", [_vm._v("Transcript Sent")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v("A transcript of this chat has been sent successfully."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }